import React from "react";
import { Button } from "antd";
import SVGIcon from "../../../utils/SVGIcon";
import { ButtonProps } from "../../Buttons/interface/ButtonInterface";
import { useAppSelector } from "../../../utils/hooks/hooks";

const ViewButton: React.FC<Partial<ButtonProps>> = ({
  action,
  data,
  permission = true,
  iconProps,
  ...rest
}) => {
  const [loading,id] =useAppSelector((state)=>state.common.viewLoading)

  if (!permission) {
    return null;
  }

  delete rest?.permissionKey;

  return (
    <Button
      type="text"
      title={"View"}
      loading={loading&&(data.id===id)&&loading}
      className=""
      onClick={() => action && action(data)}
      {...rest}
    >
      {loading&&(data.id===id)?'':<SVGIcon icon="view" width={16} {...iconProps} />}
    </Button>
  );
};

export default ViewButton;
